import axios from 'axios'

const state = {
    items: [],
    load: true,
    dataUploaded: false,
    error: false,
    errorText: '',
};
const mutations = {
    add(state, item) {
        state.items.push(item);
    },
    err(state, text) {
        state.error = true;
        state.errorText = text;
        state.load = false;
        state.dataUploaded = false;
    }
};
const actions = {
    get_list(context) {
        if (context.state.dataUploaded) return;
        context.state.load = true;
        context.state.dataUploaded = true;
        axios({
            method: 'post',
            url: '/tourclient/masterAgent/dictionary/paymentType/list',
            data: {
                request: JSON.stringify({}),
            }
        }).then(r => {
            if (r.data.ResultQueryInfo.HasError) {
                context.dispatch('error', {status: r.status,text:r.data.ResultQueryInfo.UserMessages}, {root: true});
                return;
            }
            context.state.items = [];
            r.data.Items.forEach(item => {
                item.value = item.Id;
                item.label = item.Name;
                context.commit('add', item);
            });
            context.state.load = false;
        }).catch(e => {
            context.dispatch('error', e, {root: true});
        });
    },
    re_list(context) {
        context.state.error = false;
        context.state.errorText = '';
        context.state.load = false;
        context.state.dataUploaded = false;
        context.dispatch('get_list');
    },
};
const getters = {
    list: (state) => (category) => {
        return state.items.filter(i => {
            let a = true;
            if (category || category === 0) a = i.CategoryId === category;
            return a;
        })
    },
    getById: (state, getters) => id => {
        if (!state.items.length) return null;
        return state.items.filter(i => {
            return i.value === id;
        })[0] || {};
    },
    getName: (state, getters) => id => {
        if (!state.items.length) return null;
        let a = state.items.filter(i => {
            return i.value === id;
        })[0];
        return a ? a.Name : '';
    },
};


export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}